import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface IDetailViewToolbarMoreActionsProps {
  children?: React.ReactNode;
  handleUploadFile: (file: File) => void;
  exportToExcel: () => void;
  fileName?: string;
  setFileName?: any;
}

const DetailViewToolbarMoreActions = ({ handleUploadFile, exportToExcel, fileName, setFileName }: IDetailViewToolbarMoreActionsProps) => {
  const [showPopup, setShowPopup] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isExportOpen, setIsExportOpen] = useState(false);
  const { t } = useTranslation();
  const [file, setFile] = useState<File | null>(null);

  const handlePopupToggle = () => {
    setShowPopup((prevState) => !prevState);
  };
  return (
    <div>
      <div className="dropdown">
        <button className="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false" onClick={handlePopupToggle}>
          <span className="bi bi-three-dots-vertical me-2"></span>
        </button>

        {showPopup && (
          <ul className="dropdown-menu show">
            <li>
              <button
                className="dropdown-item"
                type="button"
                onClick={() => {
                  setShowPopup(false);
                  setIsUploadModalOpen(true);
                }}
              >
                <i className="fa-solid fa-file-import me-2"></i>
                {t("Import")}
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  setIsExportOpen(true);
                }}
                className="dropdown-item"
                type="button"
              >
                <i className="fa-solid fa-file-export me-2"></i>
                {t("Export")}
              </button>
            </li>
          </ul>
        )}
      </div>
      {isUploadModalOpen && (
        <div className="modal" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Upload from Excel</h5>
                <button type="button" className="btn-close" onClick={() => setIsUploadModalOpen(false)}></button>
              </div>
              <div className="modal-body">
                <p>Select Excel file to upload:</p>
                <input
                  type="file"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const selectedFile = event.target.files?.[0];
                    if (selectedFile) {
                      setFile(selectedFile);
                    }
                  }}
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setIsUploadModalOpen(false)}>
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setIsUploadModalOpen(false);
                    if (file) {
                      handleUploadFile(file);
                    }
                  }}
                  type="button"
                  className="btn btn-primary"
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isExportOpen && (
        <div className="modal" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <label htmlFor="fileName" className="me-2">
                  File Name:
                </label>
                <input id="file-name-input" type="text" value={fileName} onChange={(event) => setFileName(event.target.value)} />
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setIsExportOpen(false)}>
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  onClick={() => {
                    exportToExcel();
                    setIsExportOpen(false);
                  }}
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailViewToolbarMoreActions;
